import { Component, OnInit } from "@angular/core";
import { AbsencesService } from "../../../../auth/service/absences.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import moment from "moment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";
import { IAbsence } from "app/auth/models/absences";

@Component({
  selector: "app-absence-user-list",
  templateUrl: "./absence-user-list.component.html",
  styleUrls: ["./absence-user-list.component.scss"],
})
export class AbsenceUserListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public searchStatus: number = 10;
  public currentAbsence: IAbsence;
  public me: ICurrentUser;

  constructor(
    public _absenceService: AbsencesService,
    public _utilService: UtilsService,
    private _routerService: Router,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.ABSENCES_USER,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.ABSENCES_USER,
            isLink: false,
          },
          {
            name: italian.data.LIST,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    await this.loadAbsence();
    this.me = await this._authenticationService.getCurrentUser();
    this._utilService.hideLoading();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadAbsence() {
    await this._absenceService.getMineAbsences();
    const approved: string = await this._utilService.translate("APPROVED_FEMALE_SINGULAR");
    const pending: string = await this._utilService.translate("PENDING");
    const notApproved: string = await this._utilService.translate("NOT_APPROVED_SINGULAR");
    this._absenceService.myAbsences.map((item: IAbsence) => {
      if (item.status === 1) {
        item.enabled_label = approved;
      } else if (item.status === 2) {
        item.enabled_label = notApproved;
      } else {
        item.enabled_label = pending;
      }
    });
  }

  absenceList() {
    let items: IAbsence[] = this._absenceService.myAbsences;
    if (items && this.me && this.me.hash) {
      items = items.filter((item: IAbsence) => item && item.employee && item.employee.hash && item.employee.hash.toLowerCase().includes(this.me.hash));
      items.sort((a, b) => (a.from < b.from ? 1 : a.from > b.from ? -1 : 0));
    }

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: IAbsence) => item.employee.complete_name.toLowerCase().includes(keywords) || item.type.name.toLowerCase().includes(keywords));
    }

    if (this.searchStatus < 3) {
      items = items.filter((item: IAbsence) => Number(item.status) === Number(this.searchStatus));
    }

    return items;
  }

  getFormat(date, absence) {
    if (absence.type.category === "permesso") {
      return moment(date).format("DD/MM/YY HH:mm");
    } else {
      return moment(date).format("DD/MM/YYYY");
    }
  }

  openModal(modal, absence) {
    this._modalService.open(modal, {
      centered: true,
      size: "sm",
    });
    this.currentAbsence = JSON.parse(JSON.stringify(absence));
  }

  loadAttachment(file: string) {
    return this._utilService.getFile(file);
  }
}
